import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { UpdateCaseLinkTypeCommand } from './update-case-link-type.command';
import { UpdateCaseLinkTypeResult } from './update-case-link-type.result';

export type { UpdateCaseLinkTypeCommand } from './update-case-link-type.command';
export type { UpdateCaseLinkTypeResult } from './update-case-link-type.result';

@Injectable({ providedIn: 'root' })
export class UpdateCaseLinkTypeUseCase {
  private readonly _repository = inject(CasesRepository);

  public execute(command: UpdateCaseLinkTypeCommand): Observable<UpdateCaseLinkTypeResult> {
    return this._repository.updateLinkType(
      command.caseId,
      command.linkedCaseId,
      command.linkType,
    ).pipe(
      map(() => ({ success: true })),
      catchError((error) => throwError(() => error)),
    );
  }
}
